import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { Api as AdministrationApi } from '../../../api/administration/api';
import {
  getAllDelegateRequests,
  GetAllDelegateRequests$Params,
} from '../../../api/administration/fn/delegations/get-all-delegate-requests';
import {
  createUserDelegationRequest,
  CreateUserDelegationRequest$Params,
} from '../../../api/administration/fn/delegations/create-user-delegation-request';
import {
  updateDelegationStatusById,
  UpdateDelegationStatusById$Params,
} from '../../../api/administration/fn/delegations/update-delegation-status-by-id';
import {
  getDelegationById,
  GetDelegationById$Params,
} from '../../../api/administration/fn/delegations/get-delegation-by-id';

import { GetUserDelegationRequestResponse } from '../../../api/administration/models/get-user-delegation-request-response';
import { UserDelegationRequestResponse } from '../../../api/administration/models/user-delegation-request-response';

@Injectable({
  providedIn: 'root',
})
export class DelegationService {
  private api = inject(AdministrationApi);

  constructor() {}

  getAllDelegateRequests(
    params: GetAllDelegateRequests$Params
  ): Observable<GetUserDelegationRequestResponse> {
    return from(this.api.invoke(getAllDelegateRequests, params));
  }

  createUserDelegationRequest(
    params: CreateUserDelegationRequest$Params
  ): Observable<UserDelegationRequestResponse> {
    return from(this.api.invoke(createUserDelegationRequest, params));
  }

  updateDelegationStatusById(
    params: UpdateDelegationStatusById$Params
  ): Observable<UserDelegationRequestResponse> {
    return from(this.api.invoke(updateDelegationStatusById, params));
  }

  getDelegationById(
    params: GetDelegationById$Params
  ): Observable<UserDelegationRequestResponse> {
    return from(this.api.invoke(getDelegationById, params));
  }
}
